import { useInstance } from '@meraki-internal/react-dependency-injection';
import { AffiliateLinkState } from './AffiliateLinkState.ts';
import { useSubscription } from '@meraki-internal/state';
import { IonButton, IonContent, IonModal } from '@ionic/react';
import { PageHeader } from '../components/page/PageHeader.tsx';
import './AffiliateLinkModal.css';

export const AffiliateLinkModal: React.FC = () => {
    const affiliateLinkState = useInstance(AffiliateLinkState);
    useSubscription(() => affiliateLinkState);

    return (
        <IonModal
            isOpen={Boolean(affiliateLinkState.showingLink)}
            onWillDismiss={() => affiliateLinkState.cancel()}
            className='affiliate-link-modal'
        >
            <PageHeader transparent onClose={() => affiliateLinkState.cancel()} />
            {affiliateLinkState.showingLink && (
                <IonContent>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginBottom: 50,
                        marginLeft: 20,
                        marginRight: 20
                    }}>
                        <img src={affiliateLinkState.showingLink.instructionsSvgPath} style={{ marginBottom: 20 }} />
                        <IonButton onClick={() => affiliateLinkState.affiliateLinkContinued(affiliateLinkState.showingLink!)}>{affiliateLinkState.showingLink.continueButton}</IonButton>
                    </div>
                </IonContent>
            )}
        </IonModal>
    );
};
